var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-layout-type',{attrs:{"data-source":'tecpage.user.menus.' + _vm.menuId + '.layout.type',"options":_vm.getActiveMenuLayoutTypes,"data-default":{ type: 'random' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }